/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet"
import Header from "./Header";
import Footer from "./Footer";
import RequestModal from "./RequestModal";
import FooterSticky from "./FooterSticky";
import SaleBlackFriday from "./SaleBlackFriday";
import { Context } from "./context.js";
import "./layout.scss";
import CompareBottomSheet from "./CompareBottomSheet/index.js";
import ProductSelectorModal from "./ProductSelectorModal/index.js";
import CompareSticky from "./CompareSticky/index.js";

function getCartInitialState() {
  if (typeof window !== `undefined`) {
    const cartData = localStorage.getItem("cartData");
    return cartData ? JSON.parse(cartData) : [];
  }
}

const Layout = ({ children, location, productURL, noSticky, isShowProduct }) => {
  const isComparePage =
    location.pathname === "/compare" ||
    location.pathname.startsWith("/compare/");

  const [popupContext, setPopupContext] = useState({
    isVisible: false,
    thanksURL: "/thank-you",
  });
  const [cartData, setCartData] = useState(getCartInitialState);
  const [compareProducts, setCompareProducts] = useState([]);
  const [isShowCompareList, setIsShowCompareList] = useState(false);
  const [selectProductInfo, setSelectProductInfo] = useState({
    isVisible: false,
    onSelect: null,
    onToggle: null,
  });

  useEffect(() => {
    if (isShowProduct) {
      document.body.classList.add("crm-product")
    } else {
      document.body.classList.remove("crm-product")
    }
  }, [isShowProduct])

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const cd = localStorage.getItem("compareProducts");
      setCompareProducts(cd ? JSON.parse(cd) : []);
    }

    const scriptId = "callrail-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://cdn.callrail.com/companies/193739955/63bab94d6071677b528e/12/swap.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  useEffect(() => {
    localStorage.setItem("cartData", JSON.stringify(cartData));
  }, [cartData, setCartData]);

  useEffect(() => {
    localStorage.setItem("compareProducts", JSON.stringify(compareProducts));
  }, [compareProducts]);

  const removeProduct = (productId) => {
    const ps = compareProducts.filter((p) => p.id !== productId);
    setCompareProducts(ps);
  };

  const addProductToComparison = (type, product) => {
    if (!compareProducts || !compareProducts.length) {
      setCompareProducts([product]);
      setIsShowCompareList(true);
      if (isComparePage && type === "card") {
        alert("Product added to the comparison list");
      }
      return;
    }

    const p = compareProducts.find((cp) => cp.id === product.id);
    if (p) {
      alert("Product already added!");
      return;
    }

    if (compareProducts.length === 4) {
      alert("You cannot add more than 4 products to compare");
      return;
    }

    const newData = [...compareProducts];
    newData.push(product);
    setCompareProducts(newData);
    setIsShowCompareList(true);

    if (isComparePage && type === "card") {
      alert("Product added to the comparison list");
    }
  };

  const clearAllComparisonData = () => {
    setCompareProducts([])
  };

  const selectProduct = () => {
    return new Promise((resolve, reject) => {
      setSelectProductInfo({
        onSelect: (p) => {
          setSelectProductInfo({
            isVisible: false,
            onSelect: null,
            onToggle: null,
          });
          resolve(p);
        },
        onToggle: (p) => {
          setSelectProductInfo({
            isVisible: false,
            onSelect: null,
            onToggle: null,
          });
          reject(p);
        },
        isVisible: true,
      });
    });
  };

  return (
    <Context.Provider
      value={{
        popupContext,
        setPopupContext,
        cartData,
        setCartData,
        compareProducts,
        addProductToComparison,
        removeProduct,
        clearAllComparisonData,
        selectProduct,
      }}
    >
      <Helmet>
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      </Helmet>
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        location={location}
      />
      <main>{children}</main>
      <Footer location={location} />
      {location.pathname !== productURL && !noSticky && (
        <SaleBlackFriday location={location} />
      )}
      <RequestModal location={location} />
      <FooterSticky />

      <ProductSelectorModal
        isVisible={selectProductInfo.isVisible}
        onToggle={selectProductInfo.onToggle || null}
        onSelect={selectProductInfo.onSelect || null}
      />

      {!isComparePage && !!compareProducts && compareProducts.length > 0 && (
        <Fragment>
          <CompareBottomSheet
            open={isShowCompareList}
            onToggle={() => setIsShowCompareList(!isShowCompareList)}
          />
          <CompareSticky openSticky={() => setIsShowCompareList(true)} />
        </Fragment>
      )}
    </Context.Provider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
